<template lang="pug">
  div.common-condition.condition(v-if="filter.label=='颜色'")
    div.condition-name
      slot(name="name") {{filter.label}}
    ul
      li(v-for="(item, i) in filter.items", @click="addFilterCondition(item, filter.attribute)",style="float:left;margin-right:0.3125rem;margin-bottom:0.3125rem")
        div.nameColor(:style="{'background-color':item.value}",:id="item.value")
  div.common-condition.condition(v-else)
    div.condition-name
      slot(name="name") {{filter.name}}
    ul
      li(v-for="(item, i) in filter.items", @click="addFilterCondition(item, filter.attribute)")
        div.name {{item.name}}
        div.num （{{item.quantity}}）

</template>
<script>
export default {
  name: 'CommonCondition',
  props: {
    addFilterCondition: {
      type: Function
    },
    filter: {
      type: Object
    }
  }
}
</script>
<style lang = "scss" scoped>
.condition {
  padding: 0 1.25rem;
}

.condition-name {
  margin: 1.25rem 0 .9375rem;
  padding: 0 0 .625rem .0625rem;
  font-size: 1.125rem;
  line-height: 1em;
  border-bottom: 1px solid #e7e7ef;
  color: #1a1a1a;
  text-transform: uppercase;
}
ul {
  list-style: none;
  padding: 0;
}

li {
  display: flex;
  flex-flow: row  nowrap;
  justify-content: flex-start;
  &:hover {
    cursor: pointer;
  }
  .nameColor {
    width:3.75rem;
    height:2rem;
  }
  #white {border:0.5px solid #B7B7BF;
  }
  .name {
    color: #0080a3;
  }
  .num {
    color: #b7b7bf;
    margin-left: .1875rem;
  }
}
</style>
